import { render, staticRenderFns } from "./CallsList.vue?vue&type=template&id=ab51d2e6&scoped=true&"
import script from "./CallsList.vue?vue&type=script&lang=js&"
export * from "./CallsList.vue?vue&type=script&lang=js&"
import style0 from "./CallsList.vue?vue&type=style&index=0&id=ab51d2e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab51d2e6",
  null
  
)

export default component.exports